import { FC, ReactElement } from 'react';
import Skeleton from 'react-loading-skeleton';

const CustomersProfilesListRowSkeleton: FC = (): ReactElement => {
  return (
    <div className="customers-profiles-list-row customers-profiles-list-row__grid-template mr-4">
      <div className="customers-profiles-list-row__element">
        <Skeleton width="50%" height={16} />
      </div>

      <div className="customers-profiles-list-row__element">
        <Skeleton width={100} height={16} />
      </div>

      <div className="customers-profiles-list-row__element flex-wrap">
        <Skeleton width={88} height={16} />
        <Skeleton width={56} height={16} />
      </div>

      <div className="customers-profiles-list-row__element flex-wrap">
        <Skeleton width={88} height={16} />
        <Skeleton width={56} height={16} />
      </div>

      <div className="customers-profiles-list-row__element">
        <Skeleton width={75} height={16} />
      </div>

      <div className="customers-profiles-list-row__element">
        <Skeleton width={40} height={16} />
      </div>

      <div className="customers-profiles-list-row__element">
        <Skeleton width={65} height={16} />
      </div>

      <div className="customers-profiles-list-row__element">
        <Skeleton width={50} height={30} style={{ borderRadius: 30 }} />
      </div>
    </div>
  );
};

export default CustomersProfilesListRowSkeleton;
